/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { BirthCertificateAreYouSureComponent} from './birth_certificate_are_you_sure.component';

export class BirthCertificateAreYouSureValidation extends IValidator {

     constructor(private component: BirthCertificateAreYouSureComponent) {
             super();
     }

     private success: boolean;

     public validate(): boolean {

          this.success = true;

          // add your valdation here!

          return this.success;

     }
     
}

